import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '../components/ui/dialog';

const galleryImages = [
  // Latest additions — March 2026 (international exhibition + community borehole installations)
  {
    url: "https://customer-assets.emergentagent.com/job_c4e4e0b2-a64a-4eeb-a271-9dd6b7a39c40/artifacts/0u7kqgws_SCC%20CEO%20and%20Mr%20Hanks.jpeg",
    alt: "SCC CEO and Mr Hanks at SMART Centre Group international exhibition",
    caption: "SCC CEO with Mr Hanks representing SMART Centres at an international exhibition"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_c4e4e0b2-a64a-4eeb-a271-9dd6b7a39c40/artifacts/0xenrur5_event%20in%20Yao.jpeg",
    alt: "SMART Centres booth showcasing low-cost climate-smart water technologies",
    caption: "SMART Centres booth being filmed at an international event"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_c4e4e0b2-a64a-4eeb-a271-9dd6b7a39c40/artifacts/ryzao0g6_WhatsApp%20Image%202026-03-06%20at%209.11.32%20PM%20%281%29.jpeg",
    alt: "Community-led borehole installation with locally produced Rope pump",
    caption: "Community celebrating a newly installed locally produced Rope pump"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_c4e4e0b2-a64a-4eeb-a271-9dd6b7a39c40/artifacts/8zgiknno_WhatsApp%20Image%202026-03-06%20at%209.11.33%20PM.jpeg",
    alt: "Local artisans and partners at a completed Rope pump installation",
    caption: "Local artisans and partners after a completed Rope pump installation"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_c4e4e0b2-a64a-4eeb-a271-9dd6b7a39c40/artifacts/5893nwhx_Ropepump-1170x500.jpg",
    alt: "Family irrigation through a Rope pump and low-cost drip tubes",
    caption: "Family irrigation through a Rope pump and low-cost drip tubes"
  },
  // Yaounde Event 2026 - Real SCC Photos
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/fjusvhx9_event%20in%20ya.jpeg",
    alt: "SMART Centre Group booth at Yaounde event",
    caption: "SMART Centre Cameroon at the Yaounde Exhibition 2026"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/sty1xqgl_event%20yaounde1.jpeg",
    alt: "Team demonstrating water technologies",
    caption: "Demonstrating SMARTech water solutions to visitors"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/qf2ihbc7_event%20in%20yaounde.jpeg",
    alt: "SMART Centre team with international partners",
    caption: "SMART Centre Cameroon team with international partners"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/e3fuqb0f_WhatsApp%20Image%202026-03-06%20at%209.11.35%20PM%20%282%29.jpeg",
    alt: "Presenting to government officials",
    caption: "Presenting SMARTech solutions to government officials"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/sk4ejcnc_WhatsApp%20Image%202026-03-06%20at%209.13.10%20PM%20%284%29.jpeg",
    alt: "Community borehole installation",
    caption: "Completed hand-drilled borehole installation"
  },
  // Additional SCC Photos
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/wrur4xg8_WhatsApp%20Image%202026-03-06%20at%209.11.32%20PM.jpeg",
    alt: "Training session with community members",
    caption: "Hands-on training with community members"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/dxakbhud_WhatsApp%20Image%202026-03-06%20at%209.11.34%20PM%20%281%29.jpeg",
    alt: "Certificate presentation ceremony",
    caption: "Trainee receiving SMART Centre certification"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/6ppgkvjz_WhatsApp%20Image%202026-03-06%20at%209.11.34%20PM%20%282%29.jpeg",
    alt: "Training graduation ceremony",
    caption: "Celebrating successful training completion"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/uepykfa2_WhatsApp%20Image%202026-03-06%20at%209.11.35%20PM.jpeg",
    alt: "Technical demonstration",
    caption: "Technical demonstration of SMARTech solutions"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/57a7xphz_WhatsApp%20Image%202026-03-06%20at%209.13.10%20PM%20%282%29.jpeg",
    alt: "Community water project",
    caption: "Community water project in progress"
  },
  // New batch - Borehole installation and certificate ceremonies
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/2s3fzjcw_WhatsApp%20Image%202026-03-06%20at%209.11.31%20PM.jpeg",
    alt: "Team at completed borehole",
    caption: "Team celebrating completed borehole installation"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/35wih8xe_WhatsApp%20Image%202026-03-06%20at%209.11.32%20PM%20%282%29.jpeg",
    alt: "Certificate presentation",
    caption: "SMART Centre certification award ceremony"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/7d07zuhp_WhatsApp%20Image%202026-03-06%20at%209.11.33%20PM%20%281%29.jpeg",
    alt: "Trainee with international trainer",
    caption: "Graduate with international SMART Centre trainer"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/evb2rcq4_WhatsApp%20Image%202026-03-06%20at%209.11.33%20PM%20%283%29.jpeg",
    alt: "Certificate handshake",
    caption: "Successful trainee receiving certification"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_wash-cameroon/artifacts/e7lv2vy8_WhatsApp%20Image%202026-03-06%20at%209.11.35%20PM%20%281%29.jpeg",
    alt: "Proud certificate holder",
    caption: "Proud graduate with SMART Centre certificate"
  }
];

const impactStats = [
  { number: '500+', label: 'Trainees Graduated' },
  { number: '50+', label: 'Communities Served' },
  { number: '100+', label: 'Boreholes Installed' },
  { number: '4', label: 'Training Programs' },
];

const successStories = [
  {
    title: "Clean Water for Wolikawo Village",
    description: "Our hand-drilled borehole project brought safe drinking water to over 200 families in Wolikawo Village, Buea. Community members were trained to maintain the system themselves.",
    impact: "200+ families now have access to clean water"
  },
  {
    title: "Women's Mushroom Cooperative",
    description: "A group of 15 women completed our mushroom farming training and established a cooperative that now supplies local markets and restaurants.",
    impact: "15 women entrepreneurs generating sustainable income"
  },
  {
    title: "School Sanitation Project",
    description: "Installed odourless latrines in 5 primary schools in Limbe, improving hygiene and reducing waterborne diseases among students.",
    impact: "1,500+ students benefiting from improved sanitation"
  }
];

export default function ImpactPage() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setSelectedImage(galleryImages[index]);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const navigateLightbox = (direction) => {
    const newIndex = direction === 'next' 
      ? (lightboxIndex + 1) % galleryImages.length
      : (lightboxIndex - 1 + galleryImages.length) % galleryImages.length;
    setLightboxIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  return (
    <div data-testid="impact-page">
      {/* Hero Section */}
      <section className="relative py-20 md:py-28 bg-primary" data-testid="impact-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            className="max-w-3xl"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-secondary font-semibold text-sm uppercase tracking-wider">Our Work</span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-4 mb-6 font-heading">
              Impact & Gallery
            </h1>
            <p className="text-xl text-blue-100">
              See the difference we're making in communities across Central Africa through sustainable technologies and skills training.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Impact Stats */}
      <section className="py-16 bg-accent" data-testid="impact-stats">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {impactStats.map((stat, index) => (
              <motion.div
                key={stat.label}
                className="bg-white p-6 rounded-2xl shadow-sm text-center"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <p className="text-4xl md:text-5xl font-bold stat-number mb-2 font-heading">{stat.number}</p>
                <p className="text-slate-600 text-sm md:text-base">{stat.label}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Photo Gallery */}
      <section className="py-16 md:py-24 bg-white" data-testid="photo-gallery">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 font-heading">
              Photo Gallery
            </h2>
            <p className="text-lg text-slate-600 mt-4">
              A glimpse into our training programs and community projects
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {galleryImages.map((image, index) => (
              <motion.div
                key={index}
                className="aspect-square overflow-hidden rounded-xl cursor-pointer img-zoom"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                onClick={() => openLightbox(index)}
                data-testid={`gallery-image-${index}`}
              >
                <img 
                  src={image.url} 
                  alt={image.alt}
                  className="w-full h-full object-cover"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Dialog */}
      <Dialog open={!!selectedImage} onOpenChange={closeLightbox}>
        <DialogContent className="max-w-4xl bg-black/95 border-none p-0">
          <DialogTitle className="sr-only">Image Lightbox</DialogTitle>
          {selectedImage && (
            <div className="relative" data-testid="lightbox">
              <button
                onClick={closeLightbox}
                className="absolute top-4 right-4 z-10 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
                data-testid="lightbox-close"
              >
                <X className="h-6 w-6 text-white" />
              </button>
              
              <button
                onClick={() => navigateLightbox('prev')}
                className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
                data-testid="lightbox-prev"
              >
                <ChevronLeft className="h-6 w-6 text-white" />
              </button>
              
              <button
                onClick={() => navigateLightbox('next')}
                className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
                data-testid="lightbox-next"
              >
                <ChevronRight className="h-6 w-6 text-white" />
              </button>

              <img 
                src={selectedImage.url} 
                alt={selectedImage.alt}
                className="w-full h-auto max-h-[80vh] object-contain"
              />
              
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent">
                <p className="text-white text-center">{selectedImage.caption}</p>
                <p className="text-white/60 text-center text-sm mt-1">
                  {lightboxIndex + 1} / {galleryImages.length}
                </p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Success Stories */}
      <section className="py-16 md:py-24 bg-accent" data-testid="success-stories">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 font-heading">
              Success Stories
            </h2>
            <p className="text-lg text-slate-600 mt-4">
              Real impact in real communities
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {successStories.map((story, index) => (
              <motion.div
                key={index}
                className="bg-white p-8 rounded-2xl shadow-md"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                data-testid={`success-story-${index}`}
              >
                <h3 className="text-xl font-bold text-slate-900 mb-4 font-heading">{story.title}</h3>
                <p className="text-slate-600 mb-4">{story.description}</p>
                <div className="bg-secondary/10 p-4 rounded-xl">
                  <p className="text-secondary font-semibold text-sm">{story.impact}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-20 bg-secondary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 font-heading">
            Be Part of Our Impact
          </h2>
          <p className="text-xl text-green-100 mb-8 max-w-2xl mx-auto">
            Join our trainings or partner with us to bring sustainable solutions to more communities.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/trainings"
              className="inline-flex items-center gap-2 bg-white text-secondary hover:bg-green-50 rounded-full px-8 py-4 font-semibold text-lg transition-all shadow-lg"
              data-testid="impact-trainings-btn"
            >
              View Trainings <ArrowRight className="h-5 w-5" />
            </Link>
            <Link 
              to="/contact"
              className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white hover:bg-white/10 rounded-full px-8 py-4 font-semibold text-lg transition-all"
              data-testid="impact-contact-btn"
            >
              Partner With Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
